jQuery("#accordion > li").click(function(){
		if(false == jQuery(this).next().is(':visible')) {
			jQuery('#accordion > ul').slideUp(300);
		}
		jQuery(this).next().slideToggle(300);
  });
	jQuery('#accordion > ul:eq(0)').show();
  
document.addEventListener("DOMContentLoaded", function () {
  console.log('Popup open');

  $('.size-chart-open-popup').magnificPopup({
    type: 'inline',
    midClick: true,
    fixedContentPos: 'auto'
  });
 
});